var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app-base-container" } },
    [
      _c(
        "a-layout",
        { style: { minHeight: "100vh" } },
        [
          _c(
            "a-layout-header",
            { attrs: { id: "main-layout-header" } },
            [_c("NetaHeaderComponent")],
            1
          ),
          _c("BulletinNotificationComponent"),
          _c(
            "a-layout-content",
            [
              _c("NetaProgressbarComponent"),
              _c(
                "keep-alive",
                { attrs: { include: "NetaListView" } },
                [_c("router-view")],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }